export default function SLA() {
  return (
    <div className="dashboard">
      <h1>SLAs</h1>
      <p>
        Percentage of performance metrics achieved over time, as specified by
        SLAs in the client contract.
      </p>
      <br />
      <iframe
        src="https://app.powerbi.com/reportEmbed?reportId=247fe636-e4bf-4ded-9131-6890a0c66d2d&autoAuth=true&ctid=b699068d-c14b-454b-a0bc-10918cf075d3"
        title="SLAs Dashboard"
        width="100%"
        height="775"
      ></iframe>
    </div>
  );
}
